import { Badge } from '@optiaxiom/react';

import type { Notification } from '../../../types';
import { getPriority, getPriorityIntent } from '../../../utils';

type PriorityCellProps = {
  notification: Notification;
};

export function PriorityCell({ notification }: PriorityCellProps) {
  const priority = getPriority(notification.type);

  return <Badge intent={getPriorityIntent(priority)}>{priority}</Badge>;
}
